import React, { useMemo } from 'react';
import renderers from './ContentViewer/rericos/renderers/index.js';
import { decorators } from './ContentViewer/rericos/decorators/index.js';
import { getPluginRenderers } from './ContentViewer/rericos/renderers/plugins/getPluginRenderers.js';
import { RicosStyles, ZIndexService } from 'ricos-styles';
import { merge } from 'lodash';
import { THEME_DEFAULTS } from './ContentViewer/defaults.js';
import RicosNodesRenderer from './ContentViewer/RicosNodesRenderer.js';
import { RicosContextProvider, ZIndexContextProvider, ContentTraverserContextProvider, RicosViewerContextProvider, RicosDirectionContextProvider, SpoilerContextProvider, RicosNodeContextProvider } from 'ricos-context';
import SpoilerManager from './ContentViewer/rericos/utils/SpoilerManager.js';
import { Decorators } from './ContentViewer/rericos/decorators/nodeViewDecorators.js';

var viewerStyles = {"fontElementMap":"rbSG8","wrapper":"Xk2HO","pluginContainerMobile":"LAzeX","viewer":"orcxI","android":"tLYKw","rootedTraversedContent":"MJXUU","atomic":"aX9x-","toolbar":"p2LoI","block":"KAnZn"};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ContentTraverser = ({
  content,
  context,
  typeMappers,
  nodeViewRenderers,
  nodeViewDecorators,
  SpoilerViewerWrapper,
  addAnchorsPrefix
}) => {
  const { documentStyle, nodes } = content;
  const { theme, isMobile } = context;
  const themeWithDefaults = merge(
    {},
    isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
    theme
  );
  const ricosStyles = new RicosStyles();
  ricosStyles.setTheme(themeWithDefaults).setDocumentStyle(documentStyle || {});
  const spoilerManager = new SpoilerManager();
  const allRenderers = useMemo(
    () => __spreadValues(__spreadValues({}, renderers), getPluginRenderers(context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper)),
    []
  );
  const allDecorators = useMemo(() => {
    return Decorators.of([...decorators, ...nodeViewDecorators], context);
  }, []);
  const ricosContext = useMemo(() => {
    const { t, locale, isMobile: isMobile2, theme: theme2, experiments, languageDir } = context;
    return {
      t,
      locale,
      isMobile: isMobile2,
      theme: theme2,
      experiments,
      languageDir
    };
  }, []);
  const zIndexService = useMemo(() => {
    return new ZIndexService(context.isMobile, context.theme.settingsStyles);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ricosStyles.toStyleTags().map((tag, i) => React.cloneElement(tag, { key: i })), /* @__PURE__ */ React.createElement(RicosContextProvider, __spreadValues({}, ricosContext), /* @__PURE__ */ React.createElement(ZIndexContextProvider, { zIndexService }, /* @__PURE__ */ React.createElement(
    ContentTraverserContextProvider,
    {
      nodeViewDecorators: allDecorators,
      renderers: allRenderers,
      SpoilerViewerWrapper
    },
    /* @__PURE__ */ React.createElement(RicosViewerContextProvider, { contextualData: context }, /* @__PURE__ */ React.createElement(RicosDirectionContextProvider, { textDirection: context.textDirection }, /* @__PURE__ */ React.createElement(SpoilerContextProvider, { spoilerManager }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: null, parentIndex: 0 }, /* @__PURE__ */ React.createElement("div", { className: viewerStyles.rootedTraversedContent }, /* @__PURE__ */ React.createElement(
      RicosNodesRenderer,
      {
        nodes,
        isRoot: true,
        addAnchorsPrefix,
        shouldParagraphApplyTextStyle: true
      }
    ))))))
  ))));
};

export { ContentTraverser as C, viewerStyles as v };
//# sourceMappingURL=ContentTraverser-6e18143f.js.map
